import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { clearAuthFromLocalStorage } from './auth-utils'
import { applicationLoginAPI, loginAPI } from '../../shared/api/auth_api'
import { TokenEnum } from '../../shared/constants/user_constants'
import { AppThunk } from '../../shared/store'

export interface AuthState {
    isAuthenticated: boolean
    loading: boolean
    idToken: string | null
    accessToken: string | null
}

const initialState: AuthState = {
    isAuthenticated: false,
    loading: false,
    idToken: localStorage.getItem("idToken"),
    accessToken: null
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setAccessToken:  (state, action: PayloadAction<string>) => {
        state.accessToken = action.payload
        state.isAuthenticated = true
    },
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
        state.isAuthenticated = action.payload
    }
  }
})


export const login = (
    idToken: string | null,
    applicationLogin: boolean = false
): AppThunk => async (dispatch) => {
    dispatch(setLoading(true))

    if (idToken === null)
        idToken = localStorage.getItem(TokenEnum.ID_TOKEN)  || ""
    
    const profile = new URLSearchParams(window.location.search).get("profile")
    if(applicationLogin){
        applicationLoginAPI(profile || "").then((res) => {
            const accessToken = res.data.access_token
            dispatch(setAccessToken(accessToken))
            localStorage.setItem(TokenEnum.ACCESS_TOKEN, accessToken)
            dispatch(setIsAuthenticated(true))

        }).catch((err) => {
            console.error("Error in applicationLoginAPI: ", err)
            clearAuthFromLocalStorage()
            dispatch(setIsAuthenticated(false))
    
        }).finally(() => {
            dispatch(setLoading(false))
        })
        
    } else {
        loginAPI(idToken).then((res) => {
            const accessToken = res.data.access_token
            dispatch(setAccessToken(accessToken))
            if (idToken !== null)
                localStorage.setItem(TokenEnum.ID_TOKEN, idToken)
            localStorage.setItem(TokenEnum.ACCESS_TOKEN, accessToken)
    
            dispatch(setIsAuthenticated(true))
    
        }).catch((err) => {
    
            console.error("Error in loginAPI: ", err)
            clearAuthFromLocalStorage()
            dispatch(setIsAuthenticated(false))
    
        }).finally(() => {
            dispatch(setLoading(false))
        })
    }
  };


export const { setLoading, setAccessToken, setIsAuthenticated} = authSlice.actions

export const sliceActions = authSlice.actions

export default authSlice.reducer